import React from "react"
import LocationInfoContainer from "@geome/shell-locator-components/lib/containers/locationInfo"
import InfoWindowView from "./view"
import withI18n from "@geome/react-next/lib/withI18n"

const InfoWindow = (props) => (
  <LocationInfoContainer>
    {(viewProps) => <InfoWindowView {...viewProps} {...props} />}
  </LocationInfoContainer>
)

export default withI18n(InfoWindow)
